export default "__VITE_ASSET__f98d4468__"